import React, { useEffect, useState } from 'react';
import {
  getLocalStorageMenuItem,
  getOrderBadgeStatusClass,
  SARIconThemeColor,
  setMobileBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileTextColor,
  setMobileTextField_BK_FONT_Border_StyleColor,
} from "../utility";
import { Badge, Container, Navbar, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";
import axios from "axios";
import { useQuery } from "react-query";
import "../css/mobileScreens.css";
import Loading from "../common/loading";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem } from "@mui/material";
import { ArrowBackOutlined, ReceiptOutlined, LocationOn, CancelOutlined, MoreVert } from "@mui/icons-material";
import { t } from "i18next";
import no_archive from "../images/no_archive.png";
import ErrorDialog from "../common/errorDialog";
import BottomNavBar from "../components/BottomNavBar";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L, { icon } from 'leaflet';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import Box from '@mui/material/Box';


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Toast from '../common/toast';

const DeliveryStatusDialog = ({ orderId, show, onHide }) => {
  const [mapCenter, setMapCenter] = useState([24.7136, 46.6753]);
  const [allTreeData, setAllTreeData] = useState(getLocalStorageMenuItem("tree_data") || [])

  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: allTreeData?.details?.motor_icon || "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: allTreeData?.details?.motor_icon || "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
    iconSize: [50, 55],
  });

  // const { data: trackingData, isLoading, isError } = useQuery(
  //   ['order-tracking', orderId],
  //   async () => {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API}/orders/${orderId}/track`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${getLocalStorageMenuItem("mobileLoginToken")}`,
  //           localization: getLocalStorageMenuItem("lang"),
  //           timeZone: getLocalStorageMenuItem("timezone")?.replace(/["]+/g, '') || ""
  //         }
  //       }
  //     );
  //     if (response.data.data?.latitude && response.data.data?.longitude) {
  //       setMapCenter([response.data.data.latitude, response.data.data.longitude]);
  //     }
  //     return response.data;
  //   },
  //   {
  //     enabled: show && !!orderId,
  //   }
  // );


  const { data: trackingData, isLoading, isError } = useQuery(
    ['order-tracking', orderId],
    async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/orders/${orderId}/track`,
        {
          headers: {
            Authorization: `Bearer ${getLocalStorageMenuItem("mobileLoginToken")}`,
            localization: getLocalStorageMenuItem("lang"),
            timeZone: getLocalStorageMenuItem("timezone")?.replace(/["]+/g, '') || ""
          }
        }
      );

      if (response.data.data?.latitude && response.data.data?.longitude) {
        setMapCenter([response.data.data.latitude, response.data.data.longitude]);
      }

      if (response.data.data?.driver_phone) {
        let phone = response.data.data.driver_phone.trim();
        if (phone.startsWith('0')) {
          phone = '+966' + phone.slice(1);
        } else if (!phone.startsWith('+966')) {
          phone = '+966' + phone;
        }
        response.data.data.driver_phone = phone;
      }

      return response.data;
    },
    {
      enabled: show && !!orderId,
    }
  );

  const getActiveStep = () => {
    if (!trackingData?.data.current_status) return 0;
    return Math.min(trackingData?.data.statuses?.indexOf(trackingData.data.current_status), trackingData?.data.statuses.length - 1);
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header className='alignByLang' closeButton style={{ backgroundColor: setMobileCardColor() }}>
        <Modal.Title style={{ color: setMobileTextColor() }}>
          <Typography className='alignByLang' variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
            {t('Order Delivery Tracking')}
          </Typography>
        </Modal.Title>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: setMobileBackColor(), padding: '24px' }}>
        <Badge style={{
          marginBottom: '16px',
          backgroundColor: getOrderBadgeStatusClass(trackingData?.data?.current_status),
        }} >{trackingData?.data?.current_status}</Badge>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <Loading backColor={setMobileBackColor()} />
          </Box>
        ) : isError ? (
          <Card className='alignByLang' sx={{ backgroundColor: setMobileCardColor() }}>
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <Typography color="error">
                {t('Failed to load tracking information')}
              </Typography>
            </CardContent>
          </Card>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Card sx={{
              backgroundColor: setMobileCardColor(),
              boxShadow: 'none',
              border: `1px solid ${setMobileCardBorderColor()}`
            }}>

              <CardContent >
                <h5 className='alignByLang' style={{ color: setMobileTextColor() }}>{t('Status History')}</h5>
                <div style={{ borderLeft: '2px solid #ddd', paddingLeft: '15px' }}>
                  {trackingData?.data.statuses?.map((status, index) => (
                    <div key={index} className="mb-3">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{
                          width: '12px',
                          height: '12px',
                          borderRadius: '50%',
                          backgroundColor: trackingData?.data.timestamp > status.date ? '#007bff' : '#6c757d',
                          marginRight: '10px'
                        }} />
                        <div>
                          <p style={{
                            color: setMobileTextColor(),
                            marginBottom: '2px',
                            fontWeight: index === 0 ? 'bold' : 'normal'
                          }}>
                            {t(status.status) || ""}
                          </p>
                          <p style={{
                            color: setMobileTextColor(),
                            fontSize: '0.8rem',
                            marginBottom: '0'
                          }}>
                            {status.date}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

              </CardContent>
            </Card>

            {/* Driver Information Card */}
            <Card className='alignByLang' sx={{
              backgroundColor: setMobileCardColor(),
              boxShadow: 'none',
              border: `1px solid ${setMobileCardBorderColor()}`
            }}>
              <CardContent className='alignByLang'>
                <Typography variant="subtitle1" gutterBottom sx={{
                  fontWeight: 'bold',
                  color: setMobileTextColor(),
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: 2
                }}>
                  <DirectionsCarIcon color="primary" fontSize="small" />
                  {t('Delivery Information')}
                </Typography>
                <Divider sx={{ my: 1, bgcolor: setMobileCardBorderColor() }} />

                <Box className='alignByLang' sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <Avatar sx={{
                    bgcolor: 'primary.main',
                    width: 40,
                    height: 40
                  }}>
                    <PersonIcon fontSize="small" />
                  </Avatar>
                  <Box className='alignByLang'>
                    <Typography variant="caption" sx={{ color: setMobileTextColor(), opacity: 0.8 }}>
                      {t('Driver')}
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: 'bold',
                      color: setMobileTextColor()
                    }}>
                      {trackingData?.data.driver_name || t('Not assigned yet')}
                    </Typography>
                  </Box>
                </Box>


                <Box className='alignByLang' sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <IconButton style={{ padding: 0 }} onClick={() => window.open(`tel:${trackingData.data.driver_phone}`, '_self')}>
                    <Avatar sx={{
                      bgcolor: 'secondary.main',
                      width: 40,
                      height: 40
                    }}>
                      <PhoneIcon fontSize="small" />
                    </Avatar>
                  </IconButton>

                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="caption" sx={{ color: setMobileTextColor(), opacity: 0.8 }}>
                      {t('Contact')}
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: 'bold',
                      color: setMobileTextColor()
                    }}>
                      {trackingData?.data.driver_phone || t('Not available')}
                    </Typography>
                  </Box>

                </Box>

                <Box className='alignByLang' sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Avatar sx={{
                    bgcolor: 'info.main',
                    width: 40,
                    height: 40
                  }}>
                    <AccessTimeIcon fontSize="small" />
                  </Avatar>
                  <Box>
                    <Typography variant="caption" sx={{ color: setMobileTextColor(), opacity: 0.8 }}>
                      {t('Last Update')}
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: 'bold',
                      color: setMobileTextColor()
                    }}>
                      {trackingData?.data.timestamp ?
                        new Date(trackingData.data.timestamp).toLocaleString() :
                        t('Not available')}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>

            {/* Map Section */}
            <Card className='alignByLang' sx={{
              backgroundColor: setMobileCardColor(),
              boxShadow: 'none',
              border: `1px solid ${setMobileCardBorderColor()}`
            }}>
              <CardContent className='alignByLang'>
                <Typography variant="subtitle1" gutterBottom sx={{
                  fontWeight: 'bold',
                  color: setMobileTextColor(),
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: 2
                }}>
                  <LocationOn color="primary" fontSize="small" />
                  {t('Current Location')}
                </Typography>
                <Divider sx={{ my: 1, bgcolor: setMobileCardBorderColor() }} />
                <Box className='alignByLang' sx={{ height: '250px', borderRadius: '8px', overflow: 'hidden' }}>
                  <MapContainer
                    center={mapCenter}
                    zoom={13}
                    style={{ height: '100%', width: '100%' }}
                  >
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    {trackingData?.data.latitude && trackingData?.data.longitude && (
                      <Marker position={[trackingData.data.latitude, trackingData.data.longitude]} />
                    )}
                  </MapContainer>
                </Box>
              </CardContent>
            </Card>
          </Box>
        )}
      </Modal.Body>
      <Modal.Footer style={{
        backgroundColor: setMobileCardColor(),
        borderTop: `1px solid ${setMobileCardBorderColor()}`,
        padding: '16px 24px'
      }}>
        <Button
          variant="outlined"
          onClick={onHide}
          sx={{
            color: setMobileTextColor(),
            borderColor: setMobileTextField_BK_FONT_Border_StyleColor().backgroundColor,
            mr: 2,
            textTransform: 'none',
            borderRadius: '8px',
            width: '50%',
            margin: 'auto',
          }}
        >
          {t('Close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const Orders = () => {
  const queryString = window.location.search;
  const urlParam = new URLSearchParams(queryString);
  const { qrName, qrCode } = useParams();
  const navigate = useNavigate();
  const lang = getLocalStorageMenuItem("lang");
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [showDeliveryDialog, setShowDeliveryDialog] = useState(false);
  const [detailsData] = useState(getLocalStorageMenuItem("tree_data").details || []);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  // Add this useEffect for responsive detection
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
      setIsDesktop(width >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    success: false,
  });
  const [cancelOrderDialog, setCancelOrderDialog] = useState({
    open: false,
    orderId: null,
    orderTotal: 0
  });


  const [menuAnchor, setMenuAnchor] = useState({});

  const handleMenuOpen = (event, orderId) => {
    event.stopPropagation();
    setMenuAnchor((prev) => ({ ...prev, [orderId]: event.currentTarget }));
  };

  const handleMenuClose = (orderId) => {
    setMenuAnchor((prev) => ({ ...prev, [orderId]: null }));
  };


  const { data: publicData, isLoading: publicIsLoading, isError: publicIsError } = useQuery("public-orders", async () => {
    const timeZone = getLocalStorageMenuItem("timezone") ? getLocalStorageMenuItem("timezone") : "";
    const MobileToken = getLocalStorageMenuItem("mobileLoginToken");
    return await axios.get(
      `${process.env.REACT_APP_API}/menus/${qrCode}/public-orders?token=${getLocalStorageMenuItem("mobileLoginToken")}`,
      { headers: { localization: lang, Authorization: `Bearer ${MobileToken}`, timeZone: timeZone.replace(/["]+/g, '') } }
    );
  });



  const handleOpenToast = (message, state) => {
    setToastSettings({
      open: true,
      success: state,
      message: message
    });
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") return;
    setToastSettings({ open: false, message: "", success: false });
  };

  const handleBack = () => {
    navigate(
      `/${qrName}/${qrCode}/sections?section=${urlParam.get("section")}&t=${urlParam.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
    );
  };

  const handleDetails = (id) => {
    navigate(
      `/${qrName}/${qrCode}/order-details?orderId=${id}&section=${urlParam.get("section")}&t=${urlParam.get("t")}`
    );
  };

  const handleTrackDelivery = (orderId, e) => {
    e.stopPropagation();
    setSelectedOrderId(orderId);
    setShowDeliveryDialog(true);
  };

  const handleCancelOrder = (orderId, totalOrder = 0, e) => {
    e.stopPropagation();
    setCancelOrderDialog({
      open: true,
      orderId: orderId,
      orderTotal: totalOrder
    });
  };

  const cancelOrderFunc = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/orders/${cancelOrderDialog.orderId}/cancel`,
        {},
        {
          headers: {
            Authorization: `Bearer ${getLocalStorageMenuItem("mobileLoginToken")}`,
            localization: getLocalStorageMenuItem("lang"),
            timeZone: getLocalStorageMenuItem("timezone")?.replace(/["]+/g, '') || ""
          },
          validateStatus: () => true
        }
      );

      if (response.status === 200) {
        handleOpenToast(t("Order cancelled successfully"), true);
        window.location.reload();
      } else {
        handleOpenToast(t(response?.data?.message), false);
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
      handleOpenToast(t("Failed to cancel order"), false);
    }
    setCancelOrderDialog({ open: false, orderId: null, orderTotal: 0 });
  }


  const onImageError = (e) => {
    e.target.src = coverSample;
  };

  if (publicIsLoading) {
    return <Loading backColor={setMobileBackColor()} />;
  }

  if (publicIsError) {
    return <ErrorDialog />;
  }

  return (
    <div className={`min-vh-100`} style={{ backgroundColor: setMobileBackColor() }}>
      <Container fluid>
        <ToastContainer />
        <div className="row">


          <div className={`${isDesktop ? '' : 'col-lg-4'} ms-auto p-0`}>
            <div style={{ marginBottom: isMobile ? "65px" : "0px" }} className={`${isDesktop ? 'container' : ''} mobile-side-screen`}>
              <Navbar
                className={`d-flex justify-content-between align-items-center position-fixed top-0 z-2 mobile-nav`}
                style={{
                  width: "100%",
                  margin: "auto",
                  backgroundColor: setMobileCardColor(),
                }}
              >
                <Button
                  onClick={handleBack}
                  style={{ color: setMobileTextColor() }}
                >
                  <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                </Button>

                <Navbar.Brand className="text-center m-0">
                  <p
                    className="mb-1 text-center sub-font"
                    style={{ color: setMobileTextColor() }}
                  >
                    {detailsData?.table}
                  </p>
                </Navbar.Brand>
              </Navbar>

              <div
                className={`mx-2 mb-4 alignByLang ${isDesktop ? 'd-flex justify-content-center flex-wrap gap-2' : ''} `}
                style={{ marginTop: "64px" }}
              >
                {publicData?.data.data?.orders.length > 0 ? (
                  publicData?.data.data?.orders?.filter(o => o.number).map((order) => (

                    <Card
                      key={order.order_id}
                      sx={{
                        mb: 2,
                        width: isDesktop ? "22%" : "100%",
                        backgroundColor: setMobileBackColor(),
                        border: `1px solid ${setMobileCardBorderColor()}`,
                        borderRadius: '12px',
                        cursor: 'pointer',
                        '&:hover': {
                          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
                        }

                      }}
                    >

                      {/* Header */}
                      <Box
                        className="head-font"
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          px: 2,
                          pt: 2,
                        }}
                      >
                        <Box sx={{ flex: 1, textAlign: 'center' }}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: setMobileTextColor() }}>
                            {t("Order")} #{order.number}
                          </Typography>
                        </Box>

                        <IconButton onClick={(e) => handleMenuOpen(e, order.order_id)}>
                          <MoreVert sx={{ color: setMobileTextColor() }} />
                        </IconButton>

                        <Menu
                          anchorEl={menuAnchor[order.order_id]}
                          open={Boolean(menuAnchor[order.order_id])}
                          onClose={() => handleMenuClose(order.order_id)}
                          style={{
                            textAlign: "center"
                          }}
                          sx={{
                            textAlign: "center"
                          }}
                        >
                          <MenuItem className="alignByLang sub-font" onClick={() => handleDetails(order.order_id)}>
                            {t("Order details")}
                          </MenuItem>
                          <MenuItem className="alignByLang sub-font"
                            style={{ display: order.status?.toLowerCase() === "waiting" ? "flex" : "none" }}
                            onClick={(e) => handleCancelOrder(order.order_id, e)}
                            disabled={(order.status || '').toLowerCase() === 'cancelled'}
                          >
                            {t("Cancel Order")}
                          </MenuItem>
                        </Menu>
                      </Box>

                      <CardContent >
                        <Box sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: 'center',
                          mb: 2
                        }}>
                          <Typography
                            className="head-font"
                            variant="h6"
                            sx={{
                              color: setMobileTextColor(),
                              fontWeight: 'bold',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            <ReceiptOutlined sx={{ color: setMobileTextColor(), mr: 1 }} fontSize="medium" />
                            {t("Order details")}
                          </Typography>

                          <Badge
                            className={` ${getOrderBadgeStatusClass(order.status)} p-2 font-size-12 sub-font`}
                            sx={{ borderRadius: '12px', fontSize: '0.75rem' }}
                          >
                            {t(order.status) || ""}
                          </Badge>
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor() }}>
                              {t("Order Time :")}
                            </Typography>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                              {order.time}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor() }}>
                              {t("Customer Name :")}
                            </Typography>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                              {order.customer}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor() }}>
                              {t("Total items :")}
                            </Typography>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                              {order.items_count}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor() }}>
                              {t("Payment method")}:
                            </Typography>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                              {order.payment_method}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor() }}>
                              {t("Total order")}:
                            </Typography>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                              {order.final_total}{" "}
                              {publicData?.data.data.currency_symbol === "SAR" ? (
                                <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" alt="SAR" />
                              ) : (
                                publicData?.data.data.currency_symbol
                              )}
                            </Typography>
                          </Box>
                        </Box>

                        {order.is_delivery_service && (
                          <Box sx={{ mt: 2 }}>
                            <Button
                              className="alignByLang head-font"
                              variant="contained"
                              startIcon={<LocationOn />}
                              onClick={(e) => handleTrackDelivery(order.order_id, e)}
                              sx={{
                                backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor().backgroundColor,
                                color: setMobileTextField_BK_FONT_Border_StyleColor().color,
                                width: '100%',
                                py: 1.5,
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                '&:hover': {
                                  backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor().backgroundColor,
                                  opacity: 0.9
                                }
                              }}
                            >
                              {t('Track Your Delivery')}
                            </Button>
                          </Box>
                        )}

                        <Button
                          className='alignByLang head-font'
                          variant="contained"
                          startIcon={<CancelOutlined style={{ marginLeft: "8px", marginRight: "8px", height: "25px" }} />}
                          onClick={(e) => handleCancelOrder(order.order_id, order.total, e)}
                          sx={{
                            backgroundColor: "#f44336",
                            color: "#fff",
                            width: '100%',
                            height: "35px",
                            display: order.status?.toLowerCase() === "waiting" ? "flex" : "none",
                            py: 1.5,
                            mt: 1,
                            borderRadius: '8px',
                            textTransform: 'none',
                            fontWeight: 'bold',
                            '&:hover': {
                              backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor().backgroundColor,
                              opacity: 0.9
                            }
                          }}
                        >
                          {t('Cancel Order')}
                        </Button>
                      </CardContent>
                    </Card>
                  ))
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minHeight: '70vh',
                      backgroundColor: setMobileCardColor(),
                      p: 3,
                      borderRadius: '12px'
                    }}
                  >
                    <Box sx={{ width: 150, height: 150, mb: 3 }}>
                      <img src={no_archive} alt="Not Found" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                    </Box>
                    <Typography variant="h6" sx={{
                      fontWeight: 'bold',
                      color: setMobileTextColor(),
                      textAlign: 'center'
                    }}>
                      {t("There are no orders")}
                    </Typography>
                  </Box>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>

      <DeliveryStatusDialog
        orderId={selectedOrderId}
        show={showDeliveryDialog}
        onHide={() => setShowDeliveryDialog(false)}
      />

      {/* Cancel Order Confirmation Dialog */}
      <Dialog
        open={cancelOrderDialog.open}
        onClose={() => setCancelOrderDialog({ open: false, orderId: null, orderTotal: 0 })}
        PaperProps={{
          sx: {
            backgroundColor: setMobileCardColor(),
            color: setMobileTextColor(),
            borderRadius: "12px",
            padding: "16px",
            minWidth: "300px"
          }
        }}
      >
        <DialogTitle className="head-font" sx={{ textAlign: "center" }}>
          {t("Cancel Order?")}
        </DialogTitle>
        <DialogContent>
          <Typography className="sub-font" sx={{ textAlign: "center" }}>
            {t("Are you sure you want to cancel this order?")}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", gap: 2, paddingBottom: "16px" }}>
          <Button
            onClick={() => setCancelOrderDialog({ open: false, orderId: null, orderTotal: 0 })}
            sx={{
              color: setMobileTextColor(),
              border: `1px solid ${setMobileCardBorderColor()}`,
              borderRadius: "8px",
              padding: "8px 16px",
              textTransform: "none",
              minWidth: "100px"
            }}
          >
            {t("No, Keep It")}
          </Button>
          <Button
            onClick={cancelOrderFunc}
            sx={{
              backgroundColor: "#f44336",
              color: "white",
              borderRadius: "8px",
              padding: "8px 16px",
              textTransform: "none",
              minWidth: "100px",
              '&:hover': {
                backgroundColor: "#d32f2f"
              }
            }}
          >
            {t("Yes, Cancel")}
          </Button>
        </DialogActions>
      </Dialog>
      <Toast
        open={toastSettings.open}
        message={toastSettings.message}
        resetToast={handleCloseToast}
        success={toastSettings.success}
      />

      <BottomNavBar qr={qrCode} qrName={qrName} />
    </div>
  );
};

export default Orders;